import { BasePage } from '@/components/ui/base-page'

export function LearningResourcesPage() {
  return (
    <BasePage
      title="undefined"
      description="undefined"
    >
      {/* Add LearningResourcesPage specific content here */}
    </BasePage>
  )
}